import axios from "axios";
import React, { useEffect, useState } from "react";
import XMLViewer from "react-xml-viewer";

const customTheme = {
  attributeKeyColor: "#994500",
  attributeValueColor: "#1a1aa6",
  tagColor: "#881280",
  textColor: "#000",
  separatorColor: "#000",
  backgroundColor: "#f8f8f8",
  collapseIndicatorColor: "#0080ff",
  fontFamily: "monospace !important",
};

const Sitemap = () => {
  const [data, setData] = useState(null);
  const getData = async () => {
    try {
      const response = await axios.get("https://api.ipo-trend.com/sitemap.xml");
      setData(response?.data);
    } catch (error) {
      console.error("Error fetching XML:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (<>

    {/* {xmlContent ? 
      <>
      <div className='XMLViewer'>
      <XMLViewer xml={xmlContent}  collapsible={true} />
      </div>
      </>
      : <p>Loading...</p>} */}
    <div className="XMLViewer">
      <div xmlns="http://www.w3.org/1999/xhtml" class="header">
      <span>This XML file does not appear to have any style information associated with it. The document tree is shown below.</span><br />
      </div>
      {data ? (
        <XMLViewer
          xml={data}
          theme={customTheme}
        // collapsible={true}
        // initialCollapsedDepth={2}
        />
      ) : (
        <p>Loading...</p>
      )}
    </div>

  </>);

};

export default Sitemap;
